module.exports = __webpack_public_path__ + "img/AL803-1.c9a76380.jpg";